import sanitizeHtml from 'sanitize-html';

export const escapeHtml = dirty => sanitizeHtml(dirty, {
    disallowedTagsMode: 'escape',
});